import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let currentRegion = null;
export const setApiRegion = (slug) => {
  currentRegion = slug;
};
api.interceptors.request.use((cfg) => {
  if (currentRegion) cfg.params = { region: currentRegion, ...cfg.params };
  return cfg;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && cfg && !cfg._retry && !cfg.url.startsWith("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(cfg);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export const fileUrl = (path) => (path ? `${BACKEND}/api/files/${path}` : null);
export const mediaUrl = (u) => (u && u.startsWith("/api") ? `${BACKEND}${u}` : u);

export function apiError(e, t) {
  const status = e?.response?.status;
  const detail = e?.response?.data?.detail;
  if (status === 403) return t("err.adultOnly");
  if (status === 429) return t("err.tooMany");
  if (typeof detail === "string") {
    if (detail.includes("Invalid email or password")) return t("err.invalidCredentials");
    if (detail.includes("already registered")) return t("err.emailTaken");
    if (detail.includes("birth date")) return t("err.birthInvalid");
    if (detail === "terms_required") return t("legal.mustAccept");
    if (detail === "min_age") return t("legal.minAge");
  }
  return t("err.generic");
}
